import { useTranslation } from "react-i18next";

import { ExternalReference } from "../trust/ExternalReference";
import { SOURCE_AND_LICENSE_ITEMS } from "../trust/content";

export function MethodologyPage() {
  const { t } = useTranslation();
  const sections = ["model", "thermal", "map", "time", "limits", "sources", "permission"] as const;
  return (
    <article className="page trust-page methodology-page">
      <header className="about-masthead"><div><span className="about-label">{t("methodology.title")}</span><h1>{t("methodology.title")}</h1></div><p>{t("methodology.intro")}</p></header>
      <div className="about-grid">
        {sections.map((section) => (
          <section className="about-card" key={section}>
            <h2>{t(`methodology.${section}Title`)}</h2><p>{t(`methodology.${section}Body`)}</p>
            {section === "sources" ? <div className="about-primary-links">{SOURCE_AND_LICENSE_ITEMS.map((item) => <ExternalReference href={item.href} key={item.href}>{item.label}</ExternalReference>)}</div> : null}
          </section>
        ))}
      </div>
    </article>
  );
}
